export default "__VITE_ASSET__qWW7vDI2__"